export default "__VITE_ASSET__DNcqMdFJ__"